import { render, staticRenderFns } from "./OrderProdctTable.vue?vue&type=template&id=4d4facdc&scoped=true&"
import script from "./OrderProdctTable.vue?vue&type=script&lang=js&"
export * from "./OrderProdctTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderProdctTable.vue?vue&type=style&index=0&id=4d4facdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4facdc",
  null
  
)

export default component.exports